import { render, staticRenderFns } from "./order.vue?vue&type=template&id=2674c68a&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=2674c68a&lang=scss&scoped=true&"
import style1 from "./order.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674c68a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2674c68a')) {
      api.createRecord('2674c68a', component.options)
    } else {
      api.reload('2674c68a', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=2674c68a&scoped=true&", function () {
      api.rerender('2674c68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/limitPrice/order.vue"
export default component.exports